import React from "react";

function HomeIcon() {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFF">
      <path d="M160-120v-480l320-240 320 240v480H560v-280H400v280H160Z"/>
    </svg>
  )

}

export default React.memo(HomeIcon);